import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import backArrow from "../assets/arrowLeftWhite.svg";
import FlutterWaveForPayment from "../assets/Home/flutterwaveLogo.webp";
import Alert from "../components/Alert";
import RegularModal from "../components/Modal/regular";
import constants from "../constants";
import { formatAmount, formatDate } from "../utils";
import { Mdas } from "./components/mdas";
import styles from "./style.module.css";

axios.defaults.testURL = constants.BASE_URL;

const Flutterwave = () => {
	const history = useHistory();
	const { state: locationState, search } = useLocation();
	const query = useMemo(() => new URLSearchParams(search), [search]);

	const [billNumber, setBillNumber] = useState(
		locationState?.billNumber || query.get("billNumber") || ""
	);
	const [noBillPaymentRef, setNoBillPaymentRef] = useState("");
	const [ownersesbn, setownersesbn] = useState(query.get("esbn") || "");
	const [fetchingESBNDetails, setFetchingESBNDetails] = useState(false);
	const [amount, setAmount] = useState(query.get("amount") || "");
	const [name, setName] = useState(query.get("name") || "");
	const [phoneNumber, setPhoneNumber] = useState(
		query.get("phoneNumber") || ""
	);
	const [email, setEmail] = useState(query.get("email") || "");
	const [getrev, setRevhead] = useState([]);
	const [address, setAddress] = useState(query.get("address") || "");
	const [revenue, setRevenue] = useState(query.get("revcode") || "");
	const [mda, setMdas] = useState(query.get("mdacode") || "");
	const [isCoreTax, setIsCoreTax] = useState(false);
	const [remark, setRemark] = useState("");
	const [paying, setPaying] = useState(false);
	const [fetchingBill, setFetchingBill] = useState(false);
	const [billInfo, setBillInfo] = useState(null);
	const [isOneChequePayment, setIsOneChequePayment] = useState(false);
	const [isDetailedPayment, setIsDetailedPayment] = useState(false);
	const [detailedPaymentId, setDetailedPaymentId] = useState("");
	const [consolidatedPaymentAlertOpen, setConsolidatedAlertOpen] =
		useState(false);
	const [payingWithBillNumber, setPayingWithBillNumber] = useState(
		query.get("method") === "2" ? false : true
	);
	const [alert, setAlert] = useState({
		showing: false,
		type: null,
		message: ""
	});

	const RevenueHead = async () => {
		const res = await axios
			.get(`/settings/mdalinkedrevenue/${mda}`)
			.then((res) => (res.data || {}).data);
		setRevhead(res);
	};

	useEffect(() => {
		RevenueHead();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [mda]);

	function randoReference() {
		var length = 10;
		var chars =
			"0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
		var result = "";
		for (var i = length; i > 0; --i)
			result += chars[Math.floor(Math.random() * chars.length)];
		return result;
	}

	useEffect(() => {
		const getBillAmount = async () => {
			try {
				setBillInfo(null);
				setFetchingBill(true);
				setRevenue("");
				setAmount("");
				setIsDetailedPayment(false);
				let bill = (
					await axios.get(`/account/billv2/${billNumber}`, {
						headers: {
							secureddata: process.env.REACT_APP_SECURED_DATA
						}
					})
				).data.data;

				setBillInfo(bill);
				setName(bill?.billDetails?.Name_on_Bill);
				setownersesbn(bill?.billDetails?.ESBN_PID_on_Bill);
				setPhoneNumber(bill?.PhoneNo);
				setEmail(bill?.Email);
				setAddress(
					bill?.billDetails?.CentralisedBillDetails[0].Address
				);

				if (bill?.billDetails?.CentralisedBillDetails?.length === 1) {
					const mdaCode =
						bill?.billDetails?.CentralisedBillDetails[0].RevenueCode.split(
							"/"
						)[0];

					setMdas(mdaCode);
					setRevenue(
						bill?.billDetails?.CentralisedBillDetails[0].RevenueCode
					);
				} else {
					if (bill?.billDetails?.Detail_Pymt_Flg) {
						setIsDetailedPayment(true);
					}

					if (!bill?.billDetails?.Consolidated_Bill_Flg) {
						const MDA =
							bill?.billDetails?.CentralisedBillDetails[0].RevenueCode.split(
								"/"
							)[0];
						setMdas(MDA);

						const MDACode =
							bill?.billDetails?.CentralisedBillDetails[0].MDA;
						const MDADeets = await axios
							.get(`/settings/mdacompany/${MDACode}`)
							.then((res) => res.data.data);

						if (MDADeets.One_Chq_Paymt) {
							setIsOneChequePayment(true);
							let highestAmountObj = {
								amount: 0,
								id: null
							};

							for (
								let i = 0;
								i <
								bill?.billDetails?.CentralisedBillDetails
									.length;
								i++
							) {
								const element =
									bill?.billDetails?.CentralisedBillDetails[
										i
									];
								if (
									parseFloat(element?.Amount) >
									highestAmountObj.amount
								) {
									highestAmountObj.amount = parseFloat(
										element.Amount
									);
									highestAmountObj.id = i;
								}
							}

							setRevenue(
								bill?.billDetails?.CentralisedBillDetails[
									highestAmountObj.id
								].RevenueCode
							);
						}
					}
				}
			} catch (error) {
				if (error.response) {
					setAlert({
						...alert,
						showing: true,
						type: "error",
						message:
							error.response.data?.msg ||
							error.response.data?.message ||
							error.response.data?.errors?.[0]?.message ||
							error.response.data?.errors?.details[0]?.message
					});
				} else {
					setAlert({
						...alert,
						showing: true,
						type: "error",
						message: error.message
					});
				}
			} finally {
				setFetchingBill(false);
			}
		};
		if (billNumber?.length >= 17) getBillAmount();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [billNumber]);

	useEffect(() => {
		// Load the FlutterwaveCheckout library
		const script = document.createElement("script");
		script.src = "https://checkout.flutterwave.com/v3.js";
		script.async = true;
		document.body.appendChild(script);

		// script.onload = () => console.log("flutterwave loaded");

		return () => document.body.removeChild(script);
	}, []);

	const getPaymentRef = async () => {
		try {
			const paymentRef = await axios.get(`getids/05`);

			setNoBillPaymentRef(paymentRef.data.Id);
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: `Payment Ref error: ${
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message ||
						error.response.data.data.message
					}`
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: `Payment Ref error: ${error.message}`
				});
			}
		}
	};

	const paymentCallback = async (paymentResponse, revCode) => {
		const requestData = {
			paymentgateway: "FLUTTERWAVE",
			paymentoption: "noEsbn",
			paygatetranid: paymentResponse?.flw_ref,
			billnumber: billNumber || noBillPaymentRef,
			billername: billInfo?.billDetails?.Name_on_Bill || name,
			billerphoneno: phoneNumber || "081111111111111",
			billeremail: email || "eirssupport@norlics.com.ng",
			amount: amount,
			mda: mda || (revenue || revCode).split("/")[0],
			revenue: revenue || revCode,
			payload: [
				{
					firstName: name,
					lastName: "",
					narration: "Flutterwave Payment",
					amount: paymentResponse?.amount,
					transactionId: paymentResponse?.flw_ref,
					processRrr: true,
					customFieldData: [
						{
							name: "rrr",
							value: paymentResponse?.flw_ref
						},
						{
							name: "payerName",
							value: name
						},
						{
							name: "itemRecId",
							value: detailedPaymentId
						},
						{
							name: "payerPhoneNumber",
							value: phoneNumber || "081111111111111"
						},
						{
							name: "payerEmail",
							value: email || "eirssupport@norlics.com.ng"
						},
						{
							name: "CustReference",
							value: name
						},
						{
							name: "CustomerId",
							value: ownersesbn
						},
						{
							name: "BillNumber",
							value: billNumber || noBillPaymentRef
						},
						{
							name: "AgencyCode",
							value: mda || (revenue || revCode).split("/")[0]
						},
						{
							name: "RevenueCode",
							value: revenue || revCode
						},
						{
							name: "Bill_from_which_Module",
							value:
								billInfo?.billDetails?.Bill_from_which_Module ||
								"",
							type: "ALL"
						},
						{
							name: "address",
							value: address,
							type: "ALL"
						},
						{
							name: "remark",
							value: remark,
							type: "ALL"
						}
					]
				}
			]
		};

		try {
			await axios.post(`/taxpaid`, requestData);

			// if (
			// 	!billNumber ||
			// 	billInfo?.billDetails?.CentralisedBillDetails?.length <= 1
			// )
			// 	payWithMonnify();
		} catch (error) {
			setPaying(false);
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message ||
						error.response.data.data.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				});
			}
		} finally {
			setIsDetailedPayment(false);
			setDetailedPaymentId("");
			setPaying(false);
			setBillNumber("");
			// setNoBillPaymentRef("");
			getPaymentRef();
			setName("");
			setPhoneNumber("");
			setEmail("");
			setownersesbn("");
			setAddress("");
			setAmount("");
			setBillInfo("");
			setRevenue("");
			setMdas("");
		}
	};

	function makePayment(amt, revCode) {
		window.FlutterwaveCheckout({
			public_key: process.env.REACT_APP_FLUTTERWAVE,
			tx_ref: randoReference(),
			amount: amt ? amt : Number(amount) || billInfo?.Balance,
			currency: "NGN",
			redirect_url: query.get("redirectURL")
				? `${query.get(
						"redirectURL"
					)}?paymentStatus=successful&billNumber=${query.get(
						"billNumber"
					)}`
				: null,
			payment_options: "card, banktransfer, ussd",
			meta: {
				source: "docs-inline-test",
				consumer_mac: "92a3-912ba-1192a",
				BillNumber: billNumber || noBillPaymentRef,
				itemRecId: detailedPaymentId,
				Amount: amount,
				CustomerId: ownersesbn,
				payerPhoneNumber: phoneNumber || "081111111111111",
				payerEmail: email || "eirssupport@norlics.com.ng",
				CustReference: name,
				Address: address,
				AgencyCode: mda || (revenue || revCode).split("/")[0],
				RevenueCode: revenue || revCode,
				Remark: remark,
				Bill_from_which_Module:
					billInfo?.billDetails?.Bill_from_which_Module || ""
			},
			customer: {
				email: email || "eirssupport@norlics.com.ng",
				phone_number: phoneNumber || "081111111111111",
				name: name
			},
			subaccounts: [
				{
					id: "RS_C695130C73A9BF1BA6857EA4FC8A46D3"
				}
			],
			customizations: {
				title: "ENUGU STATE INTERNAL REVENUE SERVICE",
				description: "Payment",
				logo: "https://checkout.flutterwave.com/assets/img/rave-logo.png"
			},
			callback: (res) => {
				paymentCallback(res);
			},
			onclose: function (incomplete) {
				if (incomplete) setPaying(false);
				else {
					setPaying(false);
					// setBillNumber("");
					// setName("");
					// setPhoneNumber("");
					// setEmail("");
					// setownersesbn("");
					// setAddress("");
					// setAmount("");
					// setBillInfo(null);
					// setRevenue("");
					// setMdas("");
					setDetailedPaymentId("");
					setAlert({
						...alert,
						showing: true,
						type: "success",
						message:
							`You have successfully paid ₦ ${
								amount.trim() || billInfo?.Balance
							}` +
							(billNumber
								? ` for bill ${billNumber}`
								: ` for ref ${noBillPaymentRef}`)
					});
					if (locationState?.billNumber) {
						if (
							billInfo?.billDetails?.CentralisedBillDetails
								?.length > 1 &&
							billInfo?.billDetails?.CentralisedBillDetails[
								billInfo?.billDetails?.CentralisedBillDetails
									?.length - 1
							].RevenueCode === revCode
						)
							locationState?.goBackTo
								? history.push(locationState?.goBackTo, {
										paymentSuccessful: true
									})
								: history.goBack();
						else if (
							billInfo?.billDetails?.CentralisedBillDetails
								?.length > 1 &&
							billInfo?.billDetails?.CentralisedBillDetails[
								billInfo?.billDetails?.CentralisedBillDetails
									?.length - 1
							].RevenueCode !== revCode
						)
							return;
						else
							locationState?.goBackTo
								? history.push(locationState?.goBackTo, {
										paymentSuccessful: true
									})
								: history.goBack();
					}
					// if this page was opened from another site other than ours
					if (query.get("redirectURL"))
						window.location.href = `${query.get(
							"redirectURL"
						)}?paymentStatus=successful&billNumber=${query.get(
							"billNumber"
						)}`;
				}
			}
		});
	}

	const startPayment = async () => {
		try {
			if (
				billInfo?.billDetails?.CentralisedBillDetails?.length > 1 &&
				!isOneChequePayment &&
				!detailedPaymentId &&
				!isDetailedPayment &&
				!amount
			) {
				billInfo?.billDetails?.CentralisedBillDetails.map(
					async (bill) => {
						await makePayment(
							+bill.Amount + +bill.OutstandingAmount,
							bill.RevenueCode
						);
					}
				);
			} else if (
				billInfo?.billDetails?.CentralisedBillDetails?.length > 1 &&
				!isOneChequePayment &&
				!detailedPaymentId &&
				!isDetailedPayment &&
				amount
			) {
				billInfo?.billDetails?.CentralisedBillDetails.map(
					async (bill) => {
						let amt =
							((+bill.Amount + +bill.OutstandingAmount) /
								billInfo?.Balance) *
							amount;

						await makePayment(amt, bill.RevenueCode);
					}
				);
			} else if (
				isDetailedPayment &&
				billInfo?.billDetails?.CentralisedBillDetails.filter(
					(bill) => bill.ItemPaidStatus !== "PAID"
				).length > 1 &&
				!detailedPaymentId &&
				!amount
			) {
				billInfo?.billDetails?.CentralisedBillDetails.filter(
					(bill) => bill.ItemPaidStatus !== "PAID"
				).map(async (bill) => {
					makePayment(+bill.ItemAmt2Pay, bill.RevenueCode);
				});
			} else if (
				isDetailedPayment &&
				billInfo?.billDetails?.CentralisedBillDetails.filter(
					(bill) => bill.ItemPaidStatus !== "PAID"
				).length > 1 &&
				!detailedPaymentId &&
				amount
			) {
				billInfo?.billDetails?.CentralisedBillDetails.filter(
					(bill) => bill.ItemPaidStatus !== "PAID"
				).map(async (bill) => {
					let amt = (+bill.ItemAmt2Pay / billInfo?.Balance) * amount;
					makePayment(amt, bill.RevenueCode);
				});
			} else makePayment();
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response?.data?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.response?.data?.msg
				});
			}
		}
	};

	const getESBNDetails = async () => {
		setFetchingESBNDetails(true);

		try {
			const res = await axios
				.get(`/users/esbnpid?anssid=${ownersesbn}`)
				.then((res) => (res.data || {}).data);

			if (res.accounttype === "individual") {
				if (!res?.firstname) {
					setName("");
					setAlert({
						...alert,
						showing: true,
						type: "error",
						message: "No data for this ESBN"
					});
				} else
					setName(
						`${res.firstname} ${res.middlename} ${res.surname}`
					);
				setAddress(res.residentialaddress || "");
				setPhoneNumber(res?.phonenumber || "");
				setEmail(res?.email || "");
			} else if (res.accounttype === "corporate") {
				setName(res.name);
				setAddress(res.stateOfficeAddress);
				setPhoneNumber(res?.phoneNumber || "");
				setEmail(res?.email || "");
			} else {
				setName(res.PayerName);
				setAddress(res.PropertyAddr);
			}
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0] ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message ||
						error.response.message
				});
			} else if (error.request) {
				setAlert((alert) => ({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				}));
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				});
			}
		} finally {
			setFetchingESBNDetails(false);
		}
	};

	async function checkCoreTaxes() {
		try {
			const res = await axios.get(
				`/txn/chkcoretax/${revenue.split("/").join("-")}`
			);

			if (res?.data?.revenueCode) setIsCoreTax(true);
			else setIsCoreTax(false);
		} catch (error) {
			if (error.response) {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message:
						error.response.data?.msg ||
						error.response.data?.errors?.[0]?.message ||
						error.response.data?.errors?.details[0]?.message
				});
			} else {
				setAlert({
					...alert,
					showing: true,
					type: "error",
					message: error.message
				});
			}
		}
	}

	useEffect(() => {
		if (!payingWithBillNumber) {
			setRevenue("");
			setownersesbn("");
			setName("");
			setPhoneNumber("");
			setEmail("");
			setAddress("");
			setAmount("");
			setRemark("");
			setIsDetailedPayment(false);
			setDetailedPaymentId("");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [mda]);

	useEffect(() => {
		if (mda && !payingWithBillNumber) checkCoreTaxes();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [revenue]);

	useEffect(() => {
		if (ownersesbn?.length >= 10 && !payingWithBillNumber) getESBNDetails();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ownersesbn]);

	useEffect(() => {
		if (detailedPaymentId) startPayment();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [detailedPaymentId]);

	useEffect(() => {
		if (!payingWithBillNumber) {
			getPaymentRef();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [payingWithBillNumber]);

	useEffect(() => {
		const delay = setTimeout(
			() =>
				setAlert({
					showing: false,
					type: null,
					message: ""
				}),
			3000
		);

		return () => clearTimeout(delay);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [!!alert.showing]);

	return (
		<div className={styles.page}>
			{alert.showing && <Alert text={alert.message} type={alert.type} />}
			{consolidatedPaymentAlertOpen && (
				<RegularModal
					showing={consolidatedPaymentAlertOpen}
					toggle={setConsolidatedAlertOpen}
				>
					<p>
						You will go through the payment{" "}
						{
							billInfo?.billDetails?.CentralisedBillDetails.filter(
								(bill) => bill.ItemPaidStatus !== "PAID"
							).length
						}{" "}
						times. Click okay to continue.{" "}
					</p>
					<button
						type="button"
						className="primary__btn"
						style={{
							display: "block",
							margin: "40px auto 0",
							padding: "0 25px"
						}}
						onClick={() => {
							setConsolidatedAlertOpen(false);
							startPayment();
						}}
					>
						Okay
					</button>
				</RegularModal>
			)}
			<main className={styles.main}>
				<div className={styles.flutterwave__header}>
					<button
						type="button"
						className={styles.go__back}
						onClick={() => history.goBack()}
					>
						<img src={backArrow} alt="go back arrow" />
					</button>
					<img src={FlutterWaveForPayment} alt="Flutterwave logo" />
				</div>
				<div className={styles.radio__btns}>
					<div>
						<input
							id="payWithBillNo"
							type="radio"
							value={true}
							checked={payingWithBillNumber}
							onChange={(e) => {
								setPayingWithBillNumber(true);
								setName("");
								setPhoneNumber("");
								setEmail("");
								setownersesbn("");
								setAmount("");
								setBillNumber("");
								setBillInfo(null);
								setAddress("");
								setRevenue("");
								setMdas("");
								setRemark("");
								setIsCoreTax(false);
								setIsDetailedPayment(false);
								setDetailedPaymentId("");
								setNoBillPaymentRef("");
							}}
							disabled={
								query.get("method") === "2" ||
								query.get("billNumber")
							}
						/>
						<label htmlFor="payWithBillNo">
							Pay With Bill Number
						</label>
					</div>
					<div>
						<input
							id="payWithoutBillNo"
							type="radio"
							value={false}
							checked={!payingWithBillNumber}
							onChange={(e) => {
								setPayingWithBillNumber(false);
								setName("");
								setPhoneNumber("");
								setEmail("");
								setownersesbn("");
								setAmount("");
								setBillNumber("");
								setBillInfo(null);
								setAddress("");
								setRevenue("");
								setMdas("");
								setRemark("");
								setIsCoreTax(false);
								setIsDetailedPayment(false);
								setDetailedPaymentId("");
								setNoBillPaymentRef("");
							}}
							disabled={
								query.get("method") === "2" ||
								query.get("billNumber")
							}
						/>
						<label htmlFor="payWithoutBillNo">
							Pay{" "}
							<b>
								<i>Without</i>
							</b>{" "}
							Bill Number
						</label>
					</div>
				</div>
				<form
					className={styles.wrapper}
					onSubmit={(e) => {
						e.preventDefault();
						setPaying(true);
						if (
							billInfo?.billDetails?.CentralisedBillDetails
								?.length > 1 &&
							!isOneChequePayment &&
							!isDetailedPayment
						)
							setConsolidatedAlertOpen(true);
						else if (
							billInfo?.billDetails?.CentralisedBillDetails
								?.length > 1 &&
							!isOneChequePayment &&
							isDetailedPayment
						) {
							if (
								billInfo?.billDetails?.CentralisedBillDetails.filter(
									(bill) => bill.ItemPaidStatus !== "PAID"
								).length > 1
							)
								setConsolidatedAlertOpen(true);
							else startPayment();
						} else startPayment();
					}}
				>
					{!payingWithBillNumber && (
						<>
							<div className={styles.single__input}>
								<label
									className={styles.input__label}
									htmlFor="paymentRef"
								>
									Payment Reference{" "}
									<span
										style={{
											fontSize: "12.5px",
											color: "#7e7e7e"
										}}
									>
										(Please save in case of need to resolve
										issue on this payment){" "}
									</span>
									<span style={{ color: "red" }}>*</span>
								</label>
								<input
									type="text"
									id="paymentRef"
									placeholder="Enter payment reference"
									value={noBillPaymentRef}
									readOnly
									required
								/>
							</div>
							<div className={styles.payments__double__inputs}>
								<Mdas
									setValue={(val) => setMdas(val)}
									value={mda}
								/>
								<div>
									<label
										className={styles.input__label}
										htmlFor="mda"
									>
										Revenue{" "}
										{!mda && (
											<span
												style={{
													fontSize: "12.5px",
													color: "#7e7e7e"
												}}
											>
												(Pick MDA first)
											</span>
										)}{" "}
										<span style={{ color: "red" }}>*</span>
									</label>
									<select
										id="mda"
										className={styles.input__medium}
										name="mda"
										onChange={(e) => {
											setRevenue(e.target.value);
											if (!payingWithBillNumber) {
												setownersesbn("");
												setName("");
												setPhoneNumber("");
												setEmail("");
												setAddress("");
												setAmount("");
												setRemark("");
											}
										}}
										value={revenue}
										disabled={
											(payingWithBillNumber &&
												(!billNumber ||
													!mda ||
													!billInfo)) ||
											(!payingWithBillNumber && !mda) ||
											query.get("method") === "2"
										}
										required
									>
										<option value="">
											{getrev
												? "--Select Revenue head--"
												: "Loading..."}
										</option>
										{getrev &&
											getrev.map((getRev) => (
												<option
													key={getRev.Code}
													value={getRev.Code}
												>
													{getRev.Description}
												</option>
											))}
									</select>
								</div>
							</div>
						</>
					)}
					{payingWithBillNumber && (
						<div className={styles.single__input}>
							<label
								className={styles.input__label}
								htmlFor="BillNumber"
							>
								Bill Number{" "}
								<span style={{ color: "red" }}>*</span>
							</label>
							<input
								type="text"
								onChange={(e) => setBillNumber(e.target.value)}
								id="BillNumber"
								placeholder="Enter bill number"
								required
								value={billNumber}
								disabled={
									query.get("billNumber") ||
									locationState?.billNumber
								}
							/>
						</div>
					)}
					<div className={styles.payments__double__inputs}>
						<div>
							<label
								className={styles.input__label}
								htmlFor="ESBN"
							>
								ESBN/PID{" "}
								{(payingWithBillNumber || isCoreTax) && (
									<span style={{ color: "red" }}>*</span>
								)}{" "}
								{!payingWithBillNumber &&
									(!mda || !revenue) && (
										<span
											style={{
												fontSize: "12.5px",
												color: "#7e7e7e"
											}}
										>
											(Pick MDA & Revenue first)
										</span>
									)}
								{ownersesbn && ownersesbn.length < 10 && (
									<span
										style={{
											fontSize: "12.5px",
											color: "red"
										}}
									>
										(Must be, at least, 10 characters long)
									</span>
								)}
							</label>
							<input
								type="text"
								id="ESBN"
								placeholder="Enter your ESBN or PID"
								required={payingWithBillNumber}
								value={ownersesbn}
								onChange={(e) => {
									setownersesbn(e.target.value);
									if (!payingWithBillNumber) {
										setName("");
										setAddress("");
										setPhoneNumber("");
										setEmail("");
									}
								}}
								disabled={
									payingWithBillNumber ||
									query.get("method") === "2" ||
									(!payingWithBillNumber &&
										(!mda || !revenue))
								}
							/>
							{fetchingESBNDetails && (
								<p
									style={{
										fontSize: "12px",
										lineHeight: "0",
										margin: "10px 0 0",
										color: "#9e9e9e"
									}}
								>
									fetching details...
								</p>
							)}
						</div>
						<div>
							<label
								className={styles.input__label}
								htmlFor="name"
							>
								Name <span style={{ color: "red" }}>*</span>{" "}
								{isCoreTax && !ownersesbn && (
									<span
										style={{
											fontSize: "12.5px",
											color: "#7e7e7e"
										}}
									>
										(Enter ESBN/PID first)
									</span>
								)}
							</label>
							<input
								type="text"
								value={name}
								onChange={(e) => setName(e.target.value)}
								id="name"
								placeholder="Enter Name"
								required
								disabled={
									payingWithBillNumber ||
									query.get("method") === "2" ||
									(!payingWithBillNumber &&
										(!mda || !revenue)) ||
									isCoreTax
								}
							/>
						</div>
					</div>
					<div className={styles.payments__double__inputs}>
						<div>
							<label
								className={styles.input__label}
								htmlFor="phoneNumber"
							>
								Phone Number
							</label>
							<input
								type="tel"
								id="phoneNumber"
								placeholder="Enter phone number"
								value={phoneNumber}
								pattern="(?:0\d{10}|\+[1-9]\d{1,14})"
								title="Please enter a valid phone number."
								minLength={11}
								onChange={(e) => setPhoneNumber(e.target.value)}
							/>
						</div>
						<div>
							<label
								className={styles.input__label}
								htmlFor="email"
							>
								Email
							</label>
							<input
								type="email"
								id="email"
								placeholder="Enter email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
							/>
						</div>
					</div>
					<div className={styles.single__input}>
						<label
							className={styles.input__label}
							htmlFor="address"
						>
							Address <span style={{ color: "red" }}>*</span>{" "}
							{isCoreTax && !ownersesbn && (
								<span
									style={{
										fontSize: "12.5px",
										color: "#7e7e7e"
									}}
								>
									(Enter ESBN/PID first)
								</span>
							)}
						</label>
						<input
							id="address"
							placeholder="Enter address"
							value={address}
							onChange={(e) => setAddress(e.target.value)}
							disabled={
								payingWithBillNumber ||
								query.get("method") === "2" ||
								(!payingWithBillNumber && (!mda || !revenue)) ||
								isCoreTax
							}
							required
						/>
					</div>
					{/* Revenue Head Bill Breakdown */}
					{fetchingBill && (
						<p style={{ textAlign: "center" }}>Loading...</p>
					)}
					{billInfo && (
						<table className={styles.table}>
							<thead>
								<tr>
									<th>S/N</th>
									<th>CATEGORY (REVENUE HEAD)</th>
									<th>Outstanding Bill (₦)</th>
									{isDetailedPayment && <th>Discount (₦)</th>}
									<th>Current Bill (₦)</th>
									{isDetailedPayment && (
										<th style={{ visibility: "hidden" }}>
											Pay
										</th>
									)}
								</tr>
							</thead>
							<tbody>
								{billInfo?.billDetails?.CentralisedBillDetails.map(
									(each, i) => (
										<tr key={each.MDA}>
											<td>{i + 1}.</td>
											<td>{each.BillDescription}</td>
											<td>
												₦
												{formatAmount(
													each.OutstandingAmount
												)}
											</td>
											{isDetailedPayment && (
												<td>
													₦
													{formatAmount(
														each.ItemDiscount
													)}
												</td>
											)}
											<td>
												₦{formatAmount(each.Amount)}
											</td>
											{isDetailedPayment &&
												(each.ItemPaidStatus ===
												"PAID" ? (
													<td>
														<span
															className={
																styles.paid__item
															}
														>
															PAID
														</span>
													</td>
												) : (
													<td>
														<button
															type="button"
															className={
																styles.detail__pay_btn
															}
															onClick={() => {
																setDetailedPaymentId(
																	each?.id
																);
																setAmount(
																	`${each?.ItemAmt2Pay}`
																);
																setRevenue(
																	each?.RevenueCode
																);
																setMdas(
																	each?.RevenueCode.split(
																		"/"
																	)[0]
																);
															}}
															disabled={paying}
														>
															{paying &&
															detailedPaymentId ===
																each?.id
																? "Paying..."
																: "Pay"}
														</button>
													</td>
												))}
										</tr>
									)
								)}
								<tr className={styles.no__border_bottom}>
									<td></td>
									<td></td>
									<td className={styles.discount}>
										DISCOUNT
									</td>
									<td className={styles.discount}>
										₦
										{formatAmount(
											billInfo?.billDetails
												?.Total_Discount_Bill_Amount
										)}
									</td>
								</tr>
								<tr className={styles.no__border_bottom}>
									<td></td>
									<td></td>
									<td className={styles.discount}>
										Total Outstanding
									</td>
									<td className={styles.discount}>
										₦
										{formatAmount(billInfo?.totOutstanding)}
									</td>
								</tr>
								<tr className={styles.no__border_bottom}>
									<td></td>
									<td></td>
									<td className={styles.total}>TOTAL DUE</td>
									<td className={styles.total}>
										₦
										{formatAmount(
											billInfo?.billDetails
												?.Total_Grand_Bill_Amount
										)}
									</td>
								</tr>
							</tbody>
						</table>
					)}
					{Boolean(billInfo?.paymentDetails?.length) && (
						<>
							<h3 className={styles.payment__history_header}>
								Bill Payment History
							</h3>
							<table className={styles.table}>
								<thead>
									<tr>
										<th>S/N</th>
										<th style={{ visibility: "hidden" }}>
											Payment Date
										</th>
										<th>Payment Date</th>
										<th>Amount Paid</th>
									</tr>
								</thead>
								<tbody>
									{billInfo?.paymentDetails.map((each, i) => (
										<tr key={each.PaymentDate}>
											<td>{i + 1}.</td>
											<td></td>
											<td>
												{formatDate(each.PaymentDate)}
											</td>
											<td>
												₦{formatAmount(each.Amount)}
											</td>
										</tr>
									))}
									<tr className={styles.no__border_bottom}>
										<td></td>
										<td></td>
										<td className={styles.discount}>
											Total Paid
										</td>
										<td className={styles.discount}>
											₦
											{formatAmount(billInfo?.totPayment)}
										</td>
									</tr>
									<tr className={styles.no__border_bottom}>
										<td></td>
										<td></td>
										<td className={styles.total}>
											Balance
										</td>
										<td className={styles.total}>
											₦{formatAmount(billInfo?.Balance)}
										</td>
									</tr>
								</tbody>
							</table>
						</>
					)}
					{billInfo?.billDetails?.CentralisedBillDetails?.length ===
						1 && (
						<div className={styles.payments__double__inputs}>
							<Mdas
								setValue={(val) => setMdas(val)}
								value={mda}
							/>
							<div>
								<label
									className={styles.input__label}
									htmlFor="revenue"
								>
									Revenue{" "}
									<span style={{ color: "red" }}>*</span>
								</label>
								<select
									id="revenue"
									className={styles.input__medium}
									name="revenue"
									onChange={(e) => {
										setRevenue(e.target.value);
									}}
									value={revenue}
									disabled={
										(payingWithBillNumber &&
											(!billNumber ||
												!mda ||
												!billInfo)) ||
										(!payingWithBillNumber && !mda) ||
										query.get("method") === "2" ||
										query.get("billNumber")
									}
									required
								>
									<option value="">
										{getrev
											? "--Select Revenue head--"
											: "Loading..."}
									</option>
									{getrev &&
										getrev.map((getRev) => (
											<option
												key={getRev.Code}
												value={getRev.Code}
											>
												{getRev.Description}
											</option>
										))}
								</select>
							</div>
						</div>
					)}
					<div className={styles.single__input}>
						<label className={styles.input__label} htmlFor="remark">
							Remark
						</label>
						<textarea
							id="remark"
							placeholder="Enter remark"
							value={remark}
							onChange={(e) => setRemark(e.target.value)}
							rows={3}
						/>
					</div>
					{locationState?.referrer !== "/coupon/purchase" &&
						query.get("method") !== "2" &&
						!query.get("billNumber") &&
						!billInfo?.billDetails?.Detail_Pymt_Flg && (
							<div className={styles.single__input}>
								<label
									className={styles.input__label}
									htmlFor="amount"
								>
									Amount to Pay (
									{billInfo?.billDetails
										?.CentralisedBillDetails?.length > 1 &&
										"Min. Amount: ₦ 2000."}{" "}
									Ignore and Click “Pay Now” to pay in full){" "}
									<span style={{ color: "red" }}>*</span>
								</label>
								<input
									type="number"
									value={amount}
									onChange={(e) => setAmount(e.target.value)}
									id="amount"
									placeholder="Enter amount"
									required={!payingWithBillNumber}
								/>
								{billInfo?.billDetails?.CentralisedBillDetails
									?.length > 1 &&
									amount &&
									amount < 2000 && (
										<span style={{ color: "red" }}>
											Amount must be, at least, ₦ 2000
										</span>
									)}
							</div>
						)}
					{!billInfo?.billDetails?.Detail_Pymt_Flg && (
						<button
							type="submit"
							className={["primary__btn", styles.btn].join(" ")}
							disabled={
								(payingWithBillNumber &&
									(!billNumber ||
										!billInfo ||
										(billInfo?.billDetails
											?.CentralisedBillDetails?.length ===
											1 &&
											(!revenue || !mda)))) ||
								(!payingWithBillNumber &&
									((ownersesbn && ownersesbn.length < 10) ||
										!name ||
										!address ||
										!mda ||
										!revenue ||
										!amount)) ||
								(isCoreTax && ownersesbn.length < 10) ||
								(amount &&
									billInfo?.billDetails
										?.CentralisedBillDetails?.length > 1 &&
									+amount < 50) ||
								(!+amount && !billInfo?.Balance) ||
								(Boolean(amount.length) && !+amount) ||
								paying
							}
						>
							{paying
								? `Paying ₦ 
						${formatAmount(amount || billInfo?.Balance)}
						... `
								: `Pay ₦ 
						${formatAmount(amount || billInfo?.Balance)}
						 now`}
						</button>
					)}
				</form>
			</main>
		</div>
	);
};

export default Flutterwave;
